import { Button } from '../components/ui/button';
import { Loader2 } from 'lucide-react';
import type { IDeleteBusinessDialogProps } from '@/@types/businessSettings';

export function DeleteBusinessDialog({
  businessName,
  isDeleting,
  onConfirm,
  onCancel,
}: IDeleteBusinessDialogProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-background rounded-lg p-6 max-w-md mx-4">
        <h3 className="text-lg font-semibold mb-2">Delete Business Profile?</h3>
        <p className="text-muted-foreground mb-4">
          Are you sure you want to delete &quot;{businessName}&quot;? This action cannot be undone.
        </p>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onCancel} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
